import $ from '../jquery-shim.js';

// Track if dynamic menu has been initialized to prevent duplicate event handlers
let dynamicMenuInitialized = false;
// Track current menu level for animation direction
let currentMenuLevel = 1;
// Track if menu is currently initializing to prevent race conditions
let menuIsInitializing = false;
// Track accordion animations to prevent conflicts
let accordionAnimating = new Set();

export function initializeMobileMenu() {
  const menuTargetNode = document.querySelector('#main-menu');
  const bodyElementForMenu = document.querySelector('body');

  // make sure we actually have a main menu
  if (menuTargetNode) {
    const observerOptions = {
      attributes: true,
      attributeFilter: ['class'],
    };

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          if ($(menuTargetNode).hasClass('mfp-hide')) {
            $(bodyElementForMenu).removeClass('mobile-menu-is-showing');
            $(menuTargetNode).hide();
            
            $("#current-level").empty();
            currentMenuLevel = 1;
            // Reset initialization flags when menu is closed
            dynamicMenuInitialized = false;
            menuIsInitializing = false;
            // Clear accordion animation tracking
            accordionAnimating.clear();
            // Show all-levels-container again for SEO crawling
            $("#all-levels-container").removeClass('tw:hidden').addClass('tw:sr-only');
          } else {
            $(bodyElementForMenu).addClass('mobile-menu-is-showing');
            $(menuTargetNode).show();
            
            // Initialize menu with a small delay to ensure DOM is ready
            setTimeout(() => {
              initDynamicMenuSwapper();
            }, 50);
          }
        }
      });
    });

    observer.observe(menuTargetNode, observerOptions);
  }
}

function initDynamicMenuSwapper(){
  // Prevent multiple initializations
  if (menuIsInitializing || dynamicMenuInitialized) {
    return;
  }
  
  menuIsInitializing = true;
  
  // Hide the all-levels-container now that we're using the interactive menu
  $("#all-levels-container").removeClass('tw:sr-only').addClass('tw:hidden');
  
  // Get the first and main menu-level where the data-level equals 1
  const menuLevel = $("#dh_main-menu-container .menu-level[data-level='1']");
  showMenuLevel(menuLevel, 1, 'initial');

  // Only add accordion toggle handler once to prevent duplicates
  if (!dynamicMenuInitialized) {
    // Remove any existing handlers first to prevent duplicates
    $( "#main-menu" ).off('click.dynamicMenu');
    
    // Handler for main item clicks (slide navigation)
    $( "#main-menu" ).on('click.dynamicMenu', '.dh_menu-item > .main-item-link', function(event){
      event.preventDefault();

      // Find the menu-level that is a sibling immediately after this item's container
      const nextLevel = $(this).closest('.dh_menu-item').nextAll('.menu-level').first();
      
      if (nextLevel.length > 0) {
        const levelData = nextLevel.data('level');
        showMenuLevel(nextLevel, levelData, 'forward');
      } else {
        // If no nextLevel, it might be a terminal link, navigate to its href
        const href = $(this).attr('href');
        if (href && href !== '#' && href !== '') {
            window.location.href = href;
        }
      }
    });
      
    // Add back button handler
    $( "#main-menu" ).on('click.dynamicMenu', '.dh-back-button', function(event){
      event.preventDefault();
      
      const parentLevelId = $(this).data('target-level');
      const menuItem = $(`#${parentLevelId}`);
      const prevLevel = menuItem.data('level');
      
      // Find parent menu level
      showMenuLevel(menuItem, prevLevel, 'backward');
    });

    $( "#main-menu" ).on('click.dynamicMenu', '.dh-accordion-title-toggle', function(event){
      event.preventDefault();
      event.stopPropagation(); // Prevent event bubbling
      
      const contentId = $(this).data('accordion-content-id');
      const $content = $('#' + contentId);
      const $arrow = $(this).find('.accordion-arrow');
      
      // Prevent multiple clicks during animation
      if (accordionAnimating.has(contentId)) {
        return;
      }
      
      // Track animation state
      accordionAnimating.add(contentId);

      $content.slideToggle(200, function() {
        // Remove from animation tracking when complete
        accordionAnimating.delete(contentId);
      });
      
      $arrow.toggleClass('tw:rotate-180');
      $(this).toggleClass('active');
    });
    
    dynamicMenuInitialized = true;
    menuIsInitializing = false;
  }
}

function showMenuLevel(menuLevel, layer, direction = 'forward'){
  const $currentLevel = $("#current-level");
  const animationDuration = 150; // ms
  
  // Don't animate on initial load
  if (direction === 'initial') {
    $currentLevel.empty();
    $(menuLevel).clone().appendTo($currentLevel);
    currentMenuLevel = layer;
    
    $currentLevel.find(".menu-level").each(function(index) {
      if($(this).data('level') !== layer){
        $(this).hide();
      } else {
        $(this).show();
      }
    });
    return;
  }
  
  // Add CSS for animations if not already present
  if (!$('#mobile-menu-animations').length) {
    $('head').append(`
      <style id="mobile-menu-animations">
        .menu-slide-out-left {
          animation: slideOutLeft ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-out-right {
          animation: slideOutRight ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-in-left {
          animation: slideInLeft ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-in-right {
          animation: slideInRight ${animationDuration}ms ease-in-out forwards;
        }
        
        @keyframes slideOutLeft {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(-100%); opacity: 0; }
        }
        
        @keyframes slideOutRight {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
        
        @keyframes slideInLeft {
          from { transform: translateX(-100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      </style>
    `);
  }
  
  // Determine slide direction
  const slideOutClass = direction === 'forward' ? 'menu-slide-out-left' : 'menu-slide-out-right';
  const slideInClass = direction === 'forward' ? 'menu-slide-in-right' : 'menu-slide-in-left';
  
  // Animate out current content
  $currentLevel.addClass(slideOutClass);
  
  // After animation completes, replace content and animate in
  setTimeout(() => {
    $currentLevel.removeClass(slideOutClass);
    $currentLevel.empty();
    $(menuLevel).clone().appendTo($currentLevel);
    
    // Show/hide appropriate levels
    $currentLevel.find(".menu-level").each(function(index) {
      if($(this).data('level') !== layer){
        $(this).hide();
      } else {
        $(this).show();
      }
    });
    
    // Animate in new content
    $currentLevel.addClass(slideInClass);
    
    // Clean up animation class after animation completes
    setTimeout(() => {
      $currentLevel.removeClass(slideInClass);
    }, animationDuration);
    
  }, animationDuration);
  
  // Update current level tracking
  currentMenuLevel = layer;
}
